/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.3
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { forwardRef } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-select components
import Select from "react-select";

// Soft UI Dashboard PRO React base styles
import colors from "assets/theme/base/colors";
import colorsDark from "assets/theme/base/ColorsDark";

// Custom styles for SoftSelect
import styles from "components/SoftSelect/styles";
import { useSystemTheme } from "context/SystemThemeContext";

const SoftSelect = forwardRef(({ size = "medium", error = false, success = false, ...rest }, ref) => {
  const { mode } = useSystemTheme();
  const isDarkMode = mode === "dark";
  const themeColors = isDarkMode ? colorsDark : colors;
  const { light } = themeColors;

  return (
    <Select
      {...rest}
      ref={ref}
      styles={styles(size, error, success, isDarkMode)}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: light.main,
          primary: light.main,
          neutral0: isDarkMode ? "#1e1e2f" : "#ffffff",
          neutral80: isDarkMode ? "#e2e8f0" : "#333333",
          neutral50: isDarkMode ? "#a0aec0" : "#999999",
          neutral40: isDarkMode ? "#a0aec0" : "#666666",
          neutral20: isDarkMode ? "#4a5568" : "#cccccc",
        },
      })}
    />
  );
});

// Typechecking props for the SoftSelect
SoftSelect.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]),
  error: PropTypes.bool,
  success: PropTypes.bool,
};

export default SoftSelect;